import service from '@/store/services/biotimes/biotime-areas-service';

const state = {
    list: [],
    biotimeArea: null,
    meta: {},
    isLoading: false,
    error: null
};

const mutations = {
    SET_LIST(state, list) {
        state.list = list;
    },
    SET_RESOURCE(state, area) {
        state.biotimeArea = area;
    },
    SET_META(state, meta) {
        state.meta = meta;
    },
    SET_LOADING(state, status) {
        state.isLoading = status;
    },
    SET_ERROR(state, error) {
        state.error = error;
    }
};

const actions = {


    get({commit, dispatch}, params) {
        return service.get(params)
            .then(biotimeArea => {
                commit('SET_RESOURCE', biotimeArea);
            });
    },
    show({commit, dispatch}, params) {
        return service.show(params)
            .then(biotimeArea => {
                commit('SET_RESOURCE', biotimeArea);
            });
    },

    list({commit}, params) {
        params = params || {};
        commit('SET_LOADING', true);
        return service.list(params)
            .then(function (response) {
                commit('SET_LIST', response.list);
                commit('SET_META', response.meta);
                return response;
            })
            .finally(function () {
                commit('SET_LOADING', false);
            });
    },

    view({commit}, params) {
        commit('SET_LOADING', true);
        return service.view(params.id, {include: params.include})
            .then(function (area) {
                commit('SET_RESOURCE', area);
                return area;
            })
            .finally(function () {
                commit('SET_LOADING', false);
            });
    },

    add({commit}, params) {
        commit('SET_LOADING', true);
        return service.add(params)
            .then(function (area) {
                commit('SET_RESOURCE', area);
                return area;
            })
            .finally(function () {
                commit('SET_LOADING', false);
            });
    },

    update({commit}, params) {
        commit('SET_LOADING', true);
        return service.update(params)
            .then(function (area) {
                commit('SET_RESOURCE', area);
                return area;
            })
            .finally(function () {
                commit('SET_LOADING', false);
            });
    },

    destroy({commit}, id) {
        return service.destroy(id);
    },
    syncAreas({commit}) {
        return service.syncAreas();
    },

    clearError({commit}) {
        commit('SET_ERROR', null);
    }
};

const getters = {
    list: function (state) { return state.list; },
    listTotal: function (state) {
        if (!state.meta) return 0;
        if (state.meta.total) return state.meta.total;
        if (state.meta.page && state.meta.page.total) return state.meta.page.total;
        return 0;
    },
    biotimeArea: function (state) { return state.area; },
    meta: function (state) { return state.meta; },
    isLoading: function (state) { return state.isLoading; },
    error: function (state) { return state.error; },
    dropdown: (state) => {
        return state.list.map(biotimeArea => ({
            id: biotimeArea.id,
        }));
    }
};

const biotimeAreas =  {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

export default biotimeAreas;
